import { render } from "./TermsModal.vue?vue&type=template&id=2e6411ac"
import script from "./TermsModal.vue?vue&type=script&lang=ts"
export * from "./TermsModal.vue?vue&type=script&lang=ts"
script.render = render

export default script